import { createContext } from "react";

import type useTrialGroupIdentityById from "src/hooks/data/load/useTrialGroupIdentityById";

/** Shares Trial Group identity loading and cached state across nested pages. */
export const TrialGroupIdentityContext = createContext<
    ReturnType<typeof useTrialGroupIdentityById>
>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});

export default TrialGroupIdentityContext;
